import { drawEliminationTypeIds, drawEliminationTypes, matchCounts } from './eventConstants';

const ROUND_SEPARATOR = ' • ';

const eliminationTypeValueById = Object.keys(drawEliminationTypeIds).reduce((acc, key) => {
    const id = drawEliminationTypeIds[key];
    const value = drawEliminationTypes[key];
    if (value != null) {
        acc[id] = value;
    }
    return acc;
}, {});

export const getEliminationTypeValue = (eliminationTypeId) => eliminationTypeValueById[eliminationTypeId] ?? null;

export const getRoundLabel = ({ eliminationTypeId, matchPosition, roundNumber, roundSize }) => {
    const eliminationType = getEliminationTypeValue(eliminationTypeId);

    if (eliminationType === drawEliminationTypes.MATCH_PLAY) {
        return `Match ${matchPosition}`;
    }
    if (eliminationType === drawEliminationTypes.ROUND_ROBIN) {
        return `R${roundNumber}`;
    }
    if (!roundSize) {
        return '';
    }
    if (roundSize === matchCounts.FINAL) {
        return 'F';
    }
    if (roundSize === matchCounts.SEMI_FINAL) {
        return `SF${ROUND_SEPARATOR}Match ${matchPosition}`;
    }
    if (roundSize === matchCounts.QUARTER_FINAL) {
        return `QF${ROUND_SEPARATOR}Match ${matchPosition}`;
    }
    return `R${roundSize * 2}${ROUND_SEPARATOR}Match ${matchPosition}`;
};
